import { useTranslation } from 'react-i18next';

const STEP_ICONS = ['📝', '🔗', '✨'];
const STEP_KEYS = ['register', 'connect', 'control'];

export default function HowItWorks() {
  const { t } = useTranslation();

  return (
    <section id="how-it-works" className="py-20 px-4 bg-gray-50 dark:bg-gray-900/50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-gray-900 dark:text-white mb-14">
          {t('landing.howItWorks.title')}
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {STEP_KEYS.map((key, i) => (
            <div key={key} className="text-center">
              <div className="w-16 h-16 rounded-2xl bg-brand-50 dark:bg-brand-500/10 mx-auto mb-4 flex items-center justify-center text-3xl">
                {STEP_ICONS[i]}
              </div>
              <div className="text-xs font-bold text-brand-600 mb-2">
                {t('landing.howItWorks.stepLabel')} {i + 1}
              </div>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
                {t(`landing.howItWorks.steps.${key}.title`)}
              </h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                {t(`landing.howItWorks.steps.${key}.description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
